import { IStatistics, IStatisticsState } from 'entities/Statistics/Statistics.models';

export const statisticsReducers = {
  setStatistics: (state: IStatisticsState, payload: IStatistics) => ({ ...state, data: payload }),
  setLoading: (state: IStatisticsState, payload: boolean) => ({ ...state, loading: payload }),
  setWatchUpdates: (state: IStatisticsState, payload: boolean) => ({ ...state, watchUpdates: payload }),
};
